module.exports = __webpack_public_path__ + "static/img/07.ee983d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/01/07.jpg
// module id = 3Z3E
// module chunks = 0